
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34 17.57C34 23.608 25.573 38 22 38c-3.573 0-12-14.393-12-20.43C10 11.168 15.385 6 22 6s12 5.167 12 11.57zm-2 .038C32 12.315 27.534 8 22 8s-10 4.315-10 9.608C12 22.698 19.735 36 22 36c2.265 0 10-13.303 10-18.392zM27 19c0 2.76-2.24 5-5 5s-5-2.24-5-5 2.24-5 5-5 5 2.24 5 5zm-2 0a3.001 3.001 0 00-6 0 3.001 3.001 0 006 0z"}})])
          )
        }
      }
    